import PassRecoveryForm from 'src/components/organisms/password-recovery'

import { usePageTitle } from 'src/hooks'

export default function PasswordRecovery({ title }: { title: string }) {
  usePageTitle(title)

  return <PassRecoveryForm />
}
